import { configureStore } from '@reduxjs/toolkit'
import hackathonReducer from './common/redux/hackathonSlice'
import userReducer from './common/redux/userSlice'

export const store = configureStore({
  reducer: {
    hackathons: hackathonReducer,
    user: userReducer,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
